import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCQcqj323dsIeXJD0eli9y644psrku6bAo",
  authDomain: "yeo-baek.firebaseapp.com",
  projectId: "yeo-baek",
  storageBucket: "yeo-baek.firebasestorage.app",
  messagingSenderId: "549615617613",
  appId: "1:549615617613:web:8387e33226dc57758c7e04",
  measurementId: "G-B2L5HFYTNP"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;